export default "/build/images/3head.png?5de6b0e80b878ff8b9d0e9448394d027";